import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControl,
  FormLabel,
} from "@mui/material";
import { classes } from "common/theme/theme";
import { FormikDimensionedNumberInput } from "common/components/FormikDimensionedNumberInput";
import { NewJobsFormState } from "../FormState";
import { typedPath } from "typed-path";
import { useSelf } from "portal/state/store";
import { useTranslation } from "react-i18next";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useState } from "react";

const S = typedPath<NewJobsFormState>();

interface PassSettingsSectionProps {}

export const PassSettingsSection: React.FC<PassSettingsSectionProps> = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);
  const { measurementSystem } = useSelf();

  return (
    <Accordion
      className="rounded-lg"
      expanded={isOpen}
      onChange={() => setIsOpen(!isOpen)}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className={classes(
          "border-x border-t border-solid border-carbon-gray-light bg-inherit",
          {
            "rounded-t-lg": isOpen,
            "border-b rounded-lg": !isOpen,
          }
        )}
      >
        {t(
          "views.autotractor.jobCreation.step3ConfigurePreview.pathPlanningSettingsHeader"
        )}
      </AccordionSummary>
      <AccordionDetails
        className={
          "border border-solid border-carbon-gray-light bg-carbon-gray-lightest dark:bg-carbon-gray-dark " +
          "rounded-b-lg grid grid-flow-row grid-cols-4 items-center gap-4"
        }
      >
        <FormControl>
          <FormLabel
            id="row-spacing-label"
            className="flex flex-row gap-2 items-center"
          >
            <span>{t("models.pathPlanning.laserWeed.rowSpacing")}</span>
          </FormLabel>
          <FormikDimensionedNumberInput
            className="w-full"
            label=""
            name={S.laserWeed.rowSpacingM.$path}
            dimensionedNumberInputProps={{
              storedUnit: "m",
              displayUnits: {
                imperial: "ft",
                metric: "m",
              },
              localSystem: measurementSystem,
              minStoredValue: 0,
              textFieldProps: {
                slotProps: {
                  htmlInput: {
                    min: 0,
                    step: 0.1,
                  },
                },
              },
            }}
            aria-labelledby="row-spacing-label"
          />
        </FormControl>
      </AccordionDetails>
    </Accordion>
  );
};
